import { useQuery, UseQueryOptions } from 'react-query';

import { AuthApi, LandingInitResponse } from 'api/AuthApi';

const LANDING_INIT_QUERY = 'landing-init';

export const useLandingInitQuery = (
  userId?: string | undefined,
  queryOptions?: UseQueryOptions<LandingInitResponse>
) => {
  return useQuery<LandingInitResponse>(
    LANDING_INIT_QUERY,
    () => AuthApi.landingInit(userId),
    {
      retry: false,
      cacheTime: 0,
      ...queryOptions,
    }
  );
};
